import localForage from 'localforage';

import events from '~/modules/game-events/game-events';
import { getSongKey, SongStats, storeSongStats, storeSongStatsByKey } from '~/modules/songs/stats/common';
import { SCORING_VERSION } from '~/modules/songs/stats/merged-track-score-fix';
import isE2E from '~/modules/utils/is-e2-e';

events.songEnded.subscribe(async (song, setup, scores, progress) => {
  if (scores.every((score) => score.score === 0)) {
    return;
  }
  let currentState = await localForage?.getItem<SongStats>(getSongKey(song));

  const score = { setup, scores, date: new Date().toISOString(), progress, scoringVersion: SCORING_VERSION };
  if (currentState) {
    // there might be cases where only { plays: number } is stored
    currentState.scores = [...(currentState?.scores ?? []), score];
    currentState.plays = currentState.scores.length;
  } else {
    currentState = {
      plays: 1,
      scores: [score],
    };
  }

  await storeSongStats(song, currentState);
  events.songStatStored.dispatch(getSongKey(song), currentState);
});

// Lets e2e tests seed play history (keyed by song id) instead of singing songs
if (isE2E()) {
  globalThis.__storeSongStats = async (songId, stats) => {
    await storeSongStatsByKey(songId, stats);
    events.songStatStored.dispatch(songId, stats);
  };
}
